import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toast = new Subject<any>();
  public notification = this.toast.asObservable();
  data = {
    title: '',
    msg: '',
    type: '',
    time: null,
    position: '' // 'left' for upload progress toast
  }

  /** Show info toast on the left (e.g. "Video uploading..."). Use for long-running uploads. */
  infoLeft(message: string, time?: number) {
    this.data = {
      title: '',
      msg: message,
      type: '_info',
      time: time != null ? time : 120000, // long duration for upload (default 2 min)
      position: 'left'
    };
    if (message) {
      this.toast.next(this.data);
    }
  }

  constructor() { }

  success(message, title?, time?: number) {
    this.data = {
      title: title,
      msg: message,
      type: '_success',
      time: time ? time : 5000,
      position: ''
    }
    if (message) {
      this.toast.next(this.data);
    }
  }

  info(message, title?, time?: number, position?: string) {
    this.data = {
      title: title,
      msg: message,
      type: '_info',
      time: time ? time : 5000,
      position: position || ''
    };
    if (message) {
      this.toast.next(this.data);
    }
  }

  warning(message, title?, time?: number) {
    this.data = {
      title: title,
      msg: message,
      type: '_warning',
      time: time ? time : 4000,
      position: ''
    }
    if (message) {
      this.toast.next(this.data);
    }
  }

  error(message: string, title?: string, time?: number) {
    this.data = {
      title: title,
      msg: message,
      type: '_error',
      time: time ? time : 5000,
      position: ''
    }
    if (message) {
      this.toast.next(this.data);
    }
  }

  copyToClipBoard(str) {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.success('Copied to clipboard');
  }

}
